var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"stat",rawName:"v-stat.brow.click",value:({ tag: 'c2c.entry' }),expression:"{ tag: 'c2c.entry' }",modifiers:{"brow":true,"click":true}}],staticClass:"c2c-entry",attrs:{"src":_vm.url},on:{"click":_setup.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }